import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";

export enum DATE_FORMAT_TYPES {
    IS_DATE = 'isDate',
    IS_DATE_AND_TIME = 'isDateTime',
    IS_TIME = 'isTime',
    IS_RAILWAYS_DATE_TIME = 'isDateRailwayTime',
    IS_DATE_WITH_TWELVE_HOURS_FORMAT = 'isDateWithTwelveHoursFormat',
    IS_TIME_WITH_TWELVE_HOURS_FORMAT = 'isTimeWithTwelveHoursFormat',
}
@Pipe({ name: 'date', pure: true })
export class CustomDatePipe extends DatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) locale: string) {
        super(locale);
    }

    transform(
        value: Date | string | number | null | undefined, datePipeArgs?, additionalProps?): string | null {
        if (!value) return;
        // If the datePipe transform is used in ts files to transform property value then create a server request ( only for format changing in the actual value )
        if (value instanceof Date) {
            return super.transform(value, datePipeArgs);
        }
        // This else part is allowed to show the date format as mentioned in the global date configuration ( only for showing purposes )
        else {
            return this.prepareDateAndOrTimeFormatToBeShown(value, datePipeArgs, additionalProps);
        }
    }

    prepareDateAndOrTimeFormatToBeShown(value, datePipeArgs: string, additionalProps: string): string {
        switch (datePipeArgs) {
            case DATE_FORMAT_TYPES.IS_DATE:
                return super.transform(value, this.adjustDateFormatAsPerPCalendar());
            case DATE_FORMAT_TYPES.IS_DATE_AND_TIME:
                return super.transform(value, this.adjustDateFormatAsPerPCalendar() + ' HH:mm:ss');
            case DATE_FORMAT_TYPES.IS_TIME:
                return super.transform(value, 'HH:mm:ss');
            case DATE_FORMAT_TYPES.IS_RAILWAYS_DATE_TIME:
                break;
            case DATE_FORMAT_TYPES.IS_DATE_WITH_TWELVE_HOURS_FORMAT:
                return super.transform(value, this.adjustDateFormatAsPerPCalendar() + ' h:mm:ss a');
            case DATE_FORMAT_TYPES.IS_TIME_WITH_TWELVE_HOURS_FORMAT:
                return super.transform(value, 'h:mm:ss a');
            default:
                if (datePipeArgs == 'HH:mm:ss') {
                    return super.transform(value, datePipeArgs);
                }
                if (datePipeArgs == 'HH:mm' || datePipeArgs == 'H:mm') {
                    return this.convertTime12to24(value, additionalProps);
                }
                // Split up the time from the iso date string format to make sure to show whether date only or both the date and time
                let index = value.toString().indexOf('T') + 1;
                let subString = value.toString().substring(index);
                if (subString !== '00:00:00') {
                    return super.transform(value, this.adjustDateFormatAsPerPCalendar() + ' HH:mm');
                }
                else if (subString === '00:00:00') {
                    return super.transform(value, this.adjustDateFormatAsPerPCalendar());
                }
        }
    }

    adjustDateFormatAsPerPCalendar(): string {
        return localStorage.getItem('globalDateFormat');
    }

    convertTime12to24 = (time12h, additionalProps) => {
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');

        if (hours === '12' && additionalProps !== 'lss') {
            hours = '00';
        }
        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }
        else if (additionalProps == 'lss') {
            if (hours == '00') {
                //hours = parseInt(hours, 10) + 12;
            }
            else {
                hours = parseInt(hours, 10);
            }
            hours = hours.toString().length == 1 ? '0' + hours.toString() : hours;
        }
        return `${hours}:${minutes}`;
    }
}